// Singleton API-клиента. Apps создают один экземпляр и переиспользуют его.
// Endpoint-функции из @dss/api-client принимают `client` + `token` параметрами.
import { createApiClient, type ApiClient } from '@dss/api-client'

const baseUrl = import.meta.env.VITE_API_BASE_URL ?? 'http://localhost:8081/api'

export const api: ApiClient = createApiClient({ baseUrl })
